<template>
  <div class="device">
    <img class="device-bg" src="images/assets/phone.png">
    <div class="embed-responsive embed-responsive-10by16 device-img">
      <video controls loop muted :poster="'videos/thumbs/'+projectId+'.png'">
        <source :src="'videos/'+projectId+'.webm'" type="video/webm">
      </video>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    projectId: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped>
.device {
  position: relative;
  display: flex;
  justify-content: center;
}
.device-bg {
  width: 18vw;
  min-width: 15rem;
  height: 100%;
}
.device-img {
  position: absolute;
  display: flex;
  justify-content: center;
  vertical-align: middle;
  top: 9%;
  width: 16.7vw;
  min-width: 13.9rem;
}
.embed-responsive-10by16::before {
  padding-top: 177.78%;
}
</style>

